import React, { Fragment } from 'react';
import { useTranslator } from 'tradera-lang';

const PaymentSummary = ({ formattedPrice, shippingOptions }) => {
    const { t } = useTranslator();

    return (
        <Fragment>
            <div
                className={`row mt-4 mt-md-5 ${
                    shippingOptions.length > 1 ? 'mb-3' : 'mb-5'
                }`}>
                <div className="col">
                    <span className="h4 text-styled">
                        {t('checkout_summary_toPayTitle')}:
                    </span>
                </div>
                <div className="text-right col">
                    <div className="font-weight-bold">
                        {t('checkout_bin_pricePlusShipping', {
                            price: formattedPrice
                        })}
                    </div>
                </div>
            </div>
            {shippingOptions.length > 1 && (
                <div className="row mb-4 mb-md-5">
                    <div className="font-italic col-10 offset-2 text-right">
                        {t('checkout_bin_shippingDescription')}
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default PaymentSummary;
